export const USERNAME_MAX_LENGTH_V108 = 18;

export const isValidUsernameV108 = (username) =>
  typeof username === 'string' &&
  username.length > 0 &&
  Array.from(username).length <= USERNAME_MAX_LENGTH_V108;
